<div [ngStyle]="styles" class="css_spinner" data-cy="spinner-icon.component">
  <div class="half left" data-cy="spinner-icon.component.left">
    <div class="band"></div>
  </div>
  <div class="half right" data-cy="spinner-icon.component.right">
    <div class="band"></div>
  </div>
</div>
